import React,{ Component } from 'react';
import i18n from '../../../../i18n';
import Input from '../../../utilities/Form/input';
import Radio from '../../../utilities/Form/radio';
import Select2 from '../../../utilities/Form/Select2';
import { StatusForm } from '../../../utilities/Const/StatusActive';
export class Form extends Component {
    constructor(props) {
        super(props)
        this.state={
            form:{
                name:'',
                status:1,
                // idDivision:null,
            },
            // divisionCurrent:null,
            // divisionText:i18n.t('Select Division'),
            // divisionList:null,
          isUpdate:0
        }
        this.handler = this.handler.bind(this)
        this.runSubmit=this.runSubmit.bind(this)
    }
   
    handler(e) {
        var key=e.target.name;
        var value=e.target.value
        this.setState({
            ...this.state, 
            form: {
                ...this.state.form,
                [key]:value
            } 
        })
    }
    handlerSelect(e,name,currentState) {
        var key=name
        var value=null
        if(e!=null){
            value=e.value
        }
        this.setState({
            ...this.state, 
            form: {
                ...this.state.form,
                [key]:value
            } 
        })
        this.setState({[currentState]:e})
    }
    runSubmit(){
       return this.state.form
    }
    renderError(name){
        const {isError,errorMessage}=this.props
        var value=''
        if(isError){
            if(errorMessage[name] !=undefined){
                value=errorMessage[name][0]
            }
        }
        return i18n.t(value);
    }
    render(){
        const {dataUpdate,isNewRecord,divisionList}=this.props
        // this.state.divisionList=divisionList   
        if(dataUpdate !=null && !isNewRecord){
            if(this.state.isUpdate==0){
                this.state.form.name=dataUpdate.name,
                // this.state.form.idDivision=dataUpdate.division_id,
                this.state.form.status=dataUpdate.status
                this.state.isUpdate=1
                // this.state.divisionCurrent={value:dataUpdate.division_id,label:((dataUpdate.division !='')?dataUpdate.name_division:this.state.divisionText)}
            }
        }
        return (
            <form>
                  {/* <Select2 
                    name={'idDivision'}
                    required={true}
                    onChange={(e)=>this.handlerSelect(e,"idDivision","divisionCurrent")}
                    options={this.state.divisionList}
                    title={i18n.t("Devision")}
                    value={this.state.divisionCurrent}
                    placeholder={this.state.divisionText}
                    error={this.renderError('idDivision')}
                /> */}
                <Input
                    type={"input"}
                    name={"name"}
                    title={i18n.t("Name")}
                    required
                    value={this.state.form.name}
                    handler={this.handler}
                    error={this.renderError('name')}
                />
                <Radio
                    list={StatusForm}
                    name={"status"}
                    title={i18n.t("Status")}
                    inline={false}
                    value={this.state.form.status}
                    handler={this.handler}
                />
            </form>
        );
    }
}

export default Form;